import {getDatTableInfo} from "@/http/services/http-services-data-table";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {createGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {Point} from "ol/geom";
import {getViewProjection} from "@/helpers/ol/ol-projection-helper";

export function toggleAccordionCollapse(selector, ariaExpanded = 'true') {

    document.querySelector(selector).querySelectorAll('.accordion-header').forEach( element => {
        showHideElement(element, ariaExpanded)
    })
}

export function showHideElement(element, ariaExpanded) {
    if (ariaExpanded === "true") {
        element.setAttribute('aria-expanded', "false")
        element.closest('.card').querySelector('.collapse').classList.remove('show')
    } else {
        element.setAttribute('aria-expanded', "true")
        const cardElement = element.closest('.card')
        if(cardElement && cardElement.querySelector('.collapse')) {
            cardElement.querySelector('.collapse').classList.add('show')
        }
    }
}

export function initLoadInfoAfterClick(element) {
    element.addEventListener('click', loadInfoAfterClick)
}

function loadInfoAfterClick(event) {

    let layer = getLayerByName('mvt-info')
    if(layer && !window.mvtFeatures) {
        const coordinates = [window.lastClickedData.data.x, window.lastClickedData.data.y]
        window.mvtFeatures = layer.getFeaturesInExtent(new Point(coordinates).transform('EPSG:28992', getViewProjection()).getExtent())
    }

    const element = event.target.closest('.accordion-header')
    const dataset = element.dataset
    const data = window.loadAfterClickForms.find(item =>
        item.PresentationID === parseInt(dataset.presentationId) &&
        item.DomainID === parseInt(dataset.domainId) &&
        item.FormID === parseInt(dataset.formId)
    )

    const dataTable = window.dataTables.find(item =>
        item.PresentationID === parseInt(dataset.presentationId) &&
        item.DomainID === parseInt(dataset.domainId) &&
        item.FormID === parseInt(dataset.formId)
    )

    if(dataTable && dataTable.table) {
        dataTable.table.columns.adjust()
    }

    if (data !== undefined) {
        blockUi(element.closest('.card'), 0.3)

        const dataTablesEmpty = element.closest('.card').querySelector('.dataTables_empty')

        if(dataTablesEmpty) {
            dataTablesEmpty.innerHTML = 'Een moment geduld a.u.b. - bezig met laden...'
        }

        getDatTableInfo(data.DomainID, data.PresentationID, data.FormID, data).then(result => {
            return result.json()
        }).then(result => {

            if(dataTablesEmpty) {
                dataTablesEmpty.innerHTML = 'Geen resultaten aanwezig in de tabel'
            }

            let rows = []
            let row
            result.features.map( (feature, index) => {

                feature.projection = 'EPSG:28992'
                createGeoJsonLayer(feature, data.FormID + '-' + index, false)
                row = {}
                row.featureid = feature.id
                dataTable.attributes.map(attribute => {

                    let value = feature.properties[attribute.Attribute]
                    if(!value) {
                        value = ''
                    } else {
                        attribute.empty = false
                    }

                    if(value !== '' && attribute.Type === 3 && attribute.Action !== 1) {
                        row[attribute.Attribute] = `<a target="_blank" href="${value}">Open link</a>`
                    } else {
                        row[attribute.Attribute] = value
                    }
                })
                rows.push(row)
            })

            // Hide empty attributes
            if(!dataTable.featureInfo.ShowEmptyFormAttributes) {
                dataTable.attributes.map( (attribute, key) => {
                    if(attribute.empty === undefined) {
                        dataTable.table.column(key + 1).visible(false)
                    }
                })
            }

            dataTable.table.rows.add(rows).draw(false)
            unblockUi(element.closest('.card'))
            element.closest('.card').querySelector('.switcher')?.classList.remove('d-none')
        })
    }
    element.removeEventListener('click', loadInfoAfterClick)
}
